<template>
    <div>
        <form
            role="form"
            class="row"
            @submit.prevent="updateData">
            <fieldset :disabled="rowData.id === 1">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="name">Ime</label>
                        <input
                            id="name"
                            v-model="rowData.name"
                            type="text"
                            class="form-control"
                            name="name"
                            placeholder="ime"
                            required>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="section">Sekcija</label>
                        <select
                            id="section"
                            v-model="rowData.section_id"
                            :disabled="rowData.api"
                            :required="!rowData.api"
                            class="form-control">
                            <option
                                v-for="section in sections"
                                :key="section.id"
                                :value="section.id">{{ section.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- sources with job class -->
                <template v-if="rowData.job_class_name">
                    <div class="col-sm-4">
                        <div class="form-group has-warning">
                            <label for="job_class_name">Job class</label>
                            <input
                                id="job_class_name"
                                v-model="rowData.job_class_name"
                                type="text"
                                class="form-control text-monospaced"
                                name="job_class_name"
                                placeholder="Job class"
                                required>
                        </div>
                    </div>
                    <div class="col-sm-1">
                        <div class="form-group has-warning">
                            <label for="job_class_name">Zunanji API</label>
                            <input
                                id="api"
                                v-model="rowData.api"
                                :required="!rowData.connection || !rowData.table"
                                type="checkbox"
                                style="display: block; height: 36px; margin: auto;"
                                name="api"
                                @click="apiToggle($event)">
                        </div>
                    </div>
                    <div class="col-sm-1">
                        <div class="form-group has-warning">
                            <label for="job_class_name">Avto. posodabljaj</label>
                            <input
                                id="auto_update"
                                v-model="rowData.auto_update"
                                type="checkbox"
                                style="display: block; height: 36px; margin: auto;"
                                name="auto_update">
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group has-warning">
                            <label for="connection">Povezava / podatkovna baza</label>
                            <select
                                id="connection"
                                v-model="rowData.connection"
                                :disabled="rowData.api"
                                :required="!rowData.api"
                                class="form-control">
                                <option
                                    v-for="connection in connections"
                                    :key="connection.id"
                                    :value="connection">{{ connection }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group has-warning">
                            <label for="table">Tabela</label>
                            <input
                                id="table"
                                v-model="rowData.table"
                                :disabled="rowData.api"
                                :required="!rowData.api"
                                type="text"
                                class="form-control"
                                name="table"
                                placeholder="Tabela">
                        </div>
                    </div>
                </template>
                <!-- sources without job class -->
                <template v-else>
                    <div class="col-sm-10">
                        <label>
                            <input
                                ref="files"
                                :multiple="false"
                                type="file"
                                accept=".json"
                                @change="handleFileUpload()">
                        </label>
                    </div>
                </template>

                <div class="col-sm-2">
                    <div class="form-group">
                        <label for="submit">&nbsp;</label>
                        <div>
                            <input
                                id="cancel"
                                type="button"
                                class="btn btn-danger"
                                value="Prekliči"
                                @click.prevent="cancel">
                            <button
                                id="submit"
                                :disabled="submitting"
                                :class="[submitting ? 'btn-warning' : 'btn-success']"
                                type="submit"
                                class="btn">
                                <i
                                    v-if="submitting"
                                    class="fa fa-hourglass" />
                                <span>Posodobi</span>
                            </button>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
        <!--label-color-picker
            :row-data="rowData"
            :show-color-picker="showColorPicker"/-->
    </div>
</template>

<script>
import TableDetails     from '../../mixins/TableDetails';
import SourcesCommon    from '../../mixins/Sources';
//import LabelColorPicker from './LabelColorPicker';
import VuejsDialog      from 'vuejs-dialog';
//import Multiselect      from 'vue-multiselect';

Vue.use(VuejsDialog);

export default {
    name: 'SourceDetails',

    components: {
        //'label-color-picker': LabelColorPicker,
        //Multiselect
    },

    mixins: [
        TableDetails,
        SourcesCommon
    ],

    data() {
        return {
            apiUrl: '/ajax/sources',
            apiHeaders: { 'Content-Type': 'multipart/form-data' },
            //showColorPicker: false,
            previousData: {},
            criticalData: [
                'job_class_name',
                'connection',
                'table',
                'api',
                'auto_update'
            ],
            sections: [],
        };
    },

    created() {
        this.backupOldData();
        this.getSections();
    },

    methods: {
        getSections() {
            axios.get('/ajax/sections', {
                params: {
                    no_paginate: 1,
                    sort: 'name|asc'
                }
            })
                .then(({data}) => {
                    this.$set(this, 'sections', [{id: null, name: ''}].concat(data.data));
                })
                .catch(error => {
                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }
                });
        },

        apiToggle(event) {
            if (event.target.checked) {
                this.$set(this.rowData, 'connection', null);
                this.$set(this.rowData, 'table', null);
            }
        },

        backupOldData() {
            this.$set(this, 'previousData', this.prepareUpdateData());
        },

        prepareUpdateData() {

            let data = (({name, connection, table, api, auto_update, job_class_name, section_id, file, /*color, background_color*/}) =>
                ({name, connection, table, api, auto_update, job_class_name, section_id, file, /*color, background_color*/})
            )(this.rowData);

            data.api         = +data.api;
            data.auto_update = +data.auto_update;

            let formData = new FormData();
            Object.keys(data).forEach( key => formData.append(key, data[key]) );

            formData.append('has_job_class', +!!data.job_class_name);

            return formData;
        },

        /**
         * Check if any critical data has changed and warn the user of the implications
         */
        updateData() {
            let data    = this.prepareUpdateData(),
                changed = this.criticalData.filter(field => data[field] !== this.previousData[field]);

            const options = {
                headers: { 'Content-Type': 'multipart/form-data' },
                multiForm: true
            };

            if (changed.length > 0) {
                let criticalText;
                switch (changed.length) {
                case 1:
                    criticalText = 'kritično polje označeno';
                    break;
                case 2:
                    criticalText = 'kritični polji označeni';
                    break;
                default:
                    criticalText = 'kritična polja označena';
                }

                this.$dialog.confirm(
                    `<h3 class="text-bold text-danger">POZOR!</h3>
                        <h4 class="text-bold">Spremenili boste ${criticalText} z <span style="color: #F39C19">rumeno</span> barvo!</h4>
                        <p>Ta sprememba lahko pri naslednji sinhronizaciji trajno poškoduje podatke v podatkovni bazi.</p>
                        <p>Ali ste prepričani, da želite nadaljevati?</p>`,
                    {
                        html:       true,
                        okText:     'Da',
                        cancelText: 'Ne',
                    })
                    .then(() => {
                        // Go ahead, fuck it up :P
                        this.backupOldData();

                        this.submit(options);
                    })
                    .catch(() => {
                        // cancel
                        this.cancel();
                    });
            } else {
                this.submit(options);
            }
        },

        cancel() {
            this.$set(this.rowData, 'name', this.previousData.name);
            this.$set(this.rowData, 'connection', this.previousData.connection);
            this.$set(this.rowData, 'table', this.previousData.table);
            this.$set(this.rowData, 'api', this.previousData.api);
            this.$set(this.rowData, 'auto_update', this.previousData.auto_update);
            this.$set(this.rowData, 'job_class_name', this.previousData.job_class_name);
            //this.$set(this.rowData, 'color', this.previousData.color);
            //this.$set(this.rowData, 'background_color', this.previousData.background_color);
            this.$set(this.rowData, 'section_id', this.previousData.section_id);
        },

        //

        handleFileUpload() {
            this.$set(this.rowData, 'file', this.$refs.files.files[0]);
        },
    }
};
</script>

<style>
    /* VueJS dialog */
    .dg-btn--ok {
        color: #fff;
        background-color: #00a65a;
        border-color: #008d4c;
    }

    .dg-btn--cancel {
        color: #fff;
        background-color: #dd4b39;
        border-color: #d73925;
    }

    /*.multiselect {
        min-height: 36px;
    }*/

    /*.multiselect__tags {
        border-radius: 0;
        min-height: 36px;
        padding-top: 7px;
    }*/

    /*.multiselect__select {
        top: 0;
    }*/
</style>

<style scoped>
    .btn {
        border-radius: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Sources/SourceDetails.vue